<template>
  <div
    class="my-2 border border-gray-200"
    :class="{
      'bg-accent-green-light border-accent-green': order.submitted,
      'bg-yellow-50 border-yellow-200': !order.submitted && editable,
      'bg-red-50 border-red-200': !editable && !order.submitted
    }">
    <div v-if="order.grouped_by_categories">
      <p v-if="order.submitted" class="mb-4 p-2 text-sm flex items-center bg-accent-green">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
        </svg>
        Bestellung wurde eingereicht.
      </p>
      <p v-else-if="!order.submitted && editable" class="mb-4 p-2 text-sm flex items-center bg-yellow-200">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
        </svg>
        Bestellung noch offen.
      </p>
      <p v-else-if="!editable" class="mb-4 p-2 text-sm flex items-center bg-red-200">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
        </svg>
        Bestellzeitraum abgelaufen
      </p>
      <div class="p-2">
        <div
          v-for="group in order.grouped_by_categories"
          :key="group.name"
          class="mb-4">
          <h4 class="font-bold opacity-50 mb-1">{{ group.name }}</h4>
          <div
            v-for="item in group.data"
            :key="item.id"
            class="border-b border-black mb-2 pb-2 last:border-b-0 last:pb-0">
            <h3 class="text-base font-bold">{{ item.name }}</h3>
            <span class="text-black text-sm"><b>{{ item.pivot.quantity }}</b> Stück, Artikel-Nr. {{ item.item_number }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderCard',
   props: {
    editable: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      required: true,
    }
  }
}
</script>

